<template>
  <div>
    <v-card elevation="0">
      <v-card-text>
        <v-form v-model="form_validate_status" ref="form">
          <v-card-title>{{
            $t("info_card.education_background_grad")
          }}</v-card-title>
          <v-divider color="white"></v-divider>
          <EducationBackgroundGradCard
            :value_universityLocation="EducationBGGrad_universityLocation"
            @input_universityLocation="
              EducationBGGrad_universityLocation = $event
            "
            :value_countryIdOfUniversity="EducationBGGrad_countryIdOfUniversity"
            @input_countryIdOfUniversity="
              EducationBGGrad_countryIdOfUniversity = $event
            "
            :value_universityName="EducationBGGrad_universityName"
            @input_universityName="EducationBGGrad_universityName = $event"
            :value_universityId="EducationBGGrad_universityId"
            @input_universityId="EducationBGGrad_universityId = $event"
            :value_graduatedYear="EducationBGGrad_graduatedYear"
            @input_graduatedYear="EducationBGGrad_graduatedYear = $event"
            :value_universityStudyStatusId="
              EducationBGGrad_universityStudyStatusId
            "
            @input_universityStudyStatusId="
              EducationBGGrad_universityStudyStatusId = $event
            "
            :value_degreeName="EducationBGGrad_degreeName"
            @input_degreeName="EducationBGGrad_degreeName = $event"
            :value_curriculumName="EducationBGGrad_curriculumName"
            @input_curriculumName="EducationBGGrad_curriculumName = $event"
            :value_GPA="EducationBGGrad_GPA"
            @input_GPA="EducationBGGrad_GPA = $event"
            :value_masterUniversityLocation="
              EducationBGGrad_masterUniversityLocation
            "
            @input_masterUniversityLocation="
              EducationBGGrad_masterUniversityLocation = $event
            "
            :value_masterCountryIdOfUniversity="
              EducationBGGrad_masterCountryIdOfUniversity
            "
            @input_masterCountryIdOfUniversity="
              EducationBGGrad_masterCountryIdOfUniversity = $event
            "
            :value_masterUniversityName="EducationBGGrad_masterUniversityName"
            @input_masterUniversityName="
              EducationBGGrad_masterUniversityName = $event
            "
            :value_masterUniversityId="EducationBGGrad_masterUniversityId"
            @input_masterUniversityId="
              EducationBGGrad_masterUniversityId = $event
            "
            :value_masterGraduatedYear="EducationBGGrad_masterGraduatedYear"
            @input_masterGraduatedYear="
              EducationBGGrad_masterGraduatedYear = $event
            "
            :value_masterUniversityStudyStatusId="
              EducationBGGrad_masterUniversityStudyStatusId
            "
            @input_masterUniversityStudyStatusId="
              EducationBGGrad_masterUniversityStudyStatusId = $event
            "
            :value_masterDegreeName="EducationBGGrad_masterDegreeName"
            @input_masterDegreeName="EducationBGGrad_masterDegreeName = $event"
            :value_masterCurriculumName="EducationBGGrad_masterCurriculumName"
            @input_masterCurriculumName="
              EducationBGGrad_masterCurriculumName = $event
            "
            :value_numOfYearWorking="EducationBGGrad_numOfYearWorking"
            @input_numOfYearWorking="
              EducationBGGrad_numOfYearWorking = $event !== '' ? $event : null
            "
            :value_companyName="EducationBGGrad_companyName"
            @input_companyName="EducationBGGrad_companyName = $event"
            :value_sinceWorking="EducationBGGrad_sinceWorking"
            @input_sinceWorking="EducationBGGrad_sinceWorking = $event"
            :value_positionInCompany="EducationBGGrad_positionInCompany"
            @input_positionInCompany="
              EducationBGGrad_positionInCompany = $event
            "
            :value_companyName1="EducationBGGrad_companyName1"
            @input_companyName1="EducationBGGrad_companyName1 = $event"
            :value_sinceWorking1="EducationBGGrad_sinceWorking1"
            @input_sinceWorking1="EducationBGGrad_sinceWorking1 = $event"
            :value_positionInCompany1="EducationBGGrad_positionInCompany1"
            @input_positionInCompany1="
              EducationBGGrad_positionInCompany1 = $event
            "
            :value_masterGPA="EducationBGGrad_masterGPA"
            @input_masterGPA="EducationBGGrad_masterGPA = $event"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-btn block elevation="0" color="success" @click="validate()">{{
          $t("menu.save")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import ApplicantInfoProvider from "@/services/applicant_info";
import EducationBackgroundGradCard from "@/components/info_cards/EducationBackgroundGrad";

const applicantInfoService = new ApplicantInfoProvider();

export default {
  name: "ApplicantInfoUniversity",
  data: function () {
    return {
      form_validate_status: null,

      EducationBGGrad_universityLocation: "inThai",
      EducationBGGrad_countryIdOfUniversity: null,
      EducationBGGrad_universityName: null,
      EducationBGGrad_universityId: null,
      EducationBGGrad_graduatedYear: null,
      EducationBGGrad_universityStudyStatusId: null,
      EducationBGGrad_degreeName: null,
      EducationBGGrad_curriculumName: null,
      EducationBGGrad_GPA: null,
      // ------------------- Master --------------------------
      EducationBGGrad_masterUniversityLocation: null,
      EducationBGGrad_masterCountryIdOfUniversity: null,
      EducationBGGrad_masterUniversityName: null,
      EducationBGGrad_masterUniversityId: null,
      EducationBGGrad_masterGraduatedYear: null,
      EducationBGGrad_masterUniversityStudyStatusId: null,
      EducationBGGrad_masterDegreeName: null,
      EducationBGGrad_masterCurriculumName: null,
      EducationBGGrad_masterGPA: null,
      // ------------------- Working Experience --------------------------
      EducationBGGrad_numOfYearWorking: null,
      EducationBGGrad_companyName: null,
      EducationBGGrad_sinceWorking: null,
      EducationBGGrad_positionInCompany: null,
      EducationBGGrad_companyName1: null,
      EducationBGGrad_sinceWorking1: null,
      EducationBGGrad_positionInCompany1: null,
    };
  },
  components: {
    EducationBackgroundGradCard,
  },

  methods: {
    async fetch_data() {
      await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const data = await applicantInfoService.getApplicantInfoUniversity(uid);
      this.EducationBGGrad_countryIdOfUniversity =
        data.COUNTRY_ID_OF_UNIVERSITY;
      this.EducationBGGrad_universityName = data.UNIVERSITY_NAME;
      this.EducationBGGrad_universityId = data.UNIVERSITY_ID;
      this.EducationBGGrad_graduatedYear = data.GRADUATED_YEAR;
      this.EducationBGGrad_universityStudyStatusId =
        data.UNIVERSITY_STUDY_STATUS;
      this.EducationBGGrad_degreeName = data.DEGREE_NAME;
      this.EducationBGGrad_curriculumName = data.CURRICULUM_NAME;
      this.EducationBGGrad_GPA = data.GPA;
      // ------------------- Master --------------------------
      this.EducationBGGrad_masterCountryIdOfUniversity =
        data.MASTER_COUNTRY_ID_OF_UNIVERSITY;
      this.EducationBGGrad_masterUniversityName = data.MASTER_UNIVERSITY_NAME;
      this.EducationBGGrad_masterUniversityId = data.MASTER_UNIVERSITY_ID;
      this.EducationBGGrad_masterGraduatedYear = data.MASTER_GRADUATED_YEAR;
      this.EducationBGGrad_masterUniversityStudyStatusId =
        data.MASTER_UNIVERSITY_STUDY_STATUS;
      this.EducationBGGrad_masterDegreeName = data.MASTER_DEGREE_NAME;
      this.EducationBGGrad_masterCurriculumName = data.MASTER_CURRICULUM_NAME;
      this.EducationBGGrad_masterGPA = data.MASTER_GPA;
      // ------------------- Working Experience --------------------------
      this.EducationBGGrad_numOfYearWorking = data.NUM_OF_YEAR_WORKING;
      this.EducationBGGrad_companyName = data.COMPANY_NAME;
      this.EducationBGGrad_sinceWorking = data.SINCE_WORKING;
      this.EducationBGGrad_positionInCompany = data.POSITION_IN_COMPANY;
      this.EducationBGGrad_companyName1 = data.COMPANY_NAME_1;
      this.EducationBGGrad_sinceWorking1 = data.SINCE_WORKING_1;
      this.EducationBGGrad_positionInCompany1 = data.POSITION_IN_COMPANY_1;

      if (data.COUNTRY_ID_OF_UNIVERSITY === "TH") {
        this.EducationBGGrad_universityLocation = "inThai";
      } else if (
        data.COUNTRY_ID_OF_UNIVERSITY &&
        data.COUNTRY_ID_OF_UNIVERSITY.length === 2
      ) {
        this.EducationBGGrad_universityLocation = "foreignCountry";
      }
      if (data.MASTER_COUNTRY_ID_OF_UNIVERSITY === "TH") {
        this.EducationBGGrad_masterUniversityLocation = "inThai";
      } else if (
        data.MASTER_COUNTRY_ID_OF_UNIVERSITY &&
        data.MASTER_COUNTRY_ID_OF_UNIVERSITY.length === 2
      ) {
        this.EducationBGGrad_masterUniversityLocation = "foreignCountry";
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.save();
      }
    },
    async save() {
      this.loading = true;
      await this.$store.dispatch("auth/getSidebarStatus");
      const uid = localStorage.getItem("uid");
      const response = await applicantInfoService
        .setApplicantInfoUniversity(
          {
            COUNTRY_ID_OF_UNIVERSITY:
              this.EducationBGGrad_universityLocation === "inThai"
                ? "TH"
                : this.EducationBGGrad_countryIdOfUniversity,
            UNIVERSITY_NAME:
              this.EducationBGGrad_universityLocation === "inThai"
                ? null
                : this.EducationBGGrad_universityName,
            UNIVERSITY_ID:
              this.EducationBGGrad_universityLocation === "inThai"
                ? this.EducationBGGrad_universityId
                : null,
            GRADUATED_YEAR: this.EducationBGGrad_graduatedYear,
            UNIVERSITY_STUDY_STATUS:
              this.EducationBGGrad_universityStudyStatusId,
            DEGREE_NAME: this.EducationBGGrad_degreeName,
            CURRICULUM_NAME: this.EducationBGGrad_curriculumName,
            GPA: this.EducationBGGrad_GPA,
            // ------------------- Master --------------------------
            MASTER_COUNTRY_ID_OF_UNIVERSITY:
              !this.EducationBGGrad_masterUniversityName &&
              !this.EducationBGGrad_masterUniversityId
                ? null
                : this.EducationBGGrad_masterUniversityLocation === "inThai"
                ? "TH"
                : this.EducationBGGrad_masterCountryIdOfUniversity,

            MASTER_UNIVERSITY_NAME:
              this.EducationBGGrad_masterUniversityLocation === "inThai"
                ? null
                : this.EducationBGGrad_masterUniversityName,
            MASTER_UNIVERSITY_ID:
              this.EducationBGGrad_masterUniversityLocation === "inThai"
                ? this.EducationBGGrad_masterUniversityId
                : null,
            MASTER_GRADUATED_YEAR: this.EducationBGGrad_masterGraduatedYear
              ? this.EducationBGGrad_masterGraduatedYear
              : null,
            MASTER_UNIVERSITY_STUDY_STATUS: this
              .EducationBGGrad_masterUniversityStudyStatusId
              ? this.EducationBGGrad_masterUniversityStudyStatusId
              : null,
            MASTER_DEGREE_NAME: this.EducationBGGrad_masterDegreeName
              ? this.EducationBGGrad_masterDegreeName
              : null,
            MASTER_CURRICULUM_NAME: this.EducationBGGrad_masterCurriculumName
              ? this.EducationBGGrad_masterCurriculumName
              : null,
            MASTER_GPA: this.EducationBGGrad_masterGPA
              ? this.EducationBGGrad_masterGPA
              : null,
            // ------------------- Working Experience ---------------
            NUM_OF_YEAR_WORKING: this.EducationBGGrad_numOfYearWorking
              ? this.EducationBGGrad_numOfYearWorking
              : null,
            COMPANY_NAME: this.EducationBGGrad_companyName
              ? this.EducationBGGrad_companyName
              : null,
            SINCE_WORKING: this.EducationBGGrad_sinceWorking
              ? this.EducationBGGrad_sinceWorking
              : null,
            POSITION_IN_COMPANY: this.EducationBGGrad_positionInCompany
              ? this.EducationBGGrad_positionInCompany
              : null,
            COMPANY_NAME_1: this.EducationBGGrad_companyName1
              ? this.EducationBGGrad_companyName1
              : null,
            SINCE_WORKING_1: this.EducationBGGrad_sinceWorking1
              ? this.EducationBGGrad_sinceWorking1
              : null,
            POSITION_IN_COMPANY_1: this.EducationBGGrad_positionInCompany1
              ? this.EducationBGGrad_positionInCompany1
              : null,
          },
          uid
        )
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.loading = false;
        });

      if (response && response.status)
        this.$toasted.success(this.$t("toasted.save_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_save"));
      this.fetch_data();
      this.loading = false;
    },
  },
  created() {
    this.fetch_data();
  },
};
</script>
